import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { NutritionPage } from './nutrition';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [NutritionPage],
    imports: [PagesModule, ComponentsModule],
    exports: [NutritionPage]
})
export class NutritionPageModule { }
